import {
  Caption1,
  makeStyles,
  shorthands,
  tokens,
  mergeClasses
} from '@fluentui/react-components';
import React from 'react';

const styles = makeStyles({
  durationTextContainer: {
    width: '100%',
    height: '20px',
    paddingTop: '1px',
    paddingRight: '0px',
    paddingBottom: '3px',
    paddingLeft: '0px',
    rowGap: '0px',
    columnGap: '0px',
    opacity: '0px',
  },
  durationText: {
    color: tokens.colorBrandBackgroundInverted,
  },
  playerTimeSeparator: {
    ...shorthands.padding('0', tokens.spacingHorizontalXS),
  },
});

export const TimeAndDuration = ({ useFormattedTimeAndDuration }) => {
  const classes = styles();
  const [time, duration] = useFormattedTimeAndDuration();

  return (
    <div className={mergeClasses(classes.durationTextContainer, 'clipchamp-player-duration-text')}>
      <Caption1 className={classes.durationText}>
        <span>{time}</span>
        <span className={classes.playerTimeSeparator}>/</span>
        <span>{duration}</span>
      </Caption1>
    </div>
  );
};
